import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(contractId, request) {
  return axios.post(
    api.path("contractDatabase.store", { contractId: contractId }),
    request
  );
}

export function update(contractId, databaseId, request) {
  return axios.put(
    api.path("contractDatabase.update", {
      contractId: contractId,
      databaseId: databaseId
    }),
    request
  );
}

export function show(contractId, databaseId) {
  return axios.get(
    api.path("contractDatabase.show", {
      contractId: contractId,
      databaseId: databaseId
    })
  );
}

export function list(contractId) {
  return axios.get(
    api.path("contractDatabase.index", { contractId: contractId })
  );
}

export function remove(contractId, databaseId) {
  return axios.delete(
    api.path("contractDatabase.remove", {
      contractId: contractId,
      databaseId: databaseId
    })
  );
}

export function turnOn(contractId, databaseId, request) {
  return axios.put(
    api.path("contractDatabase.turnOn", {
      contractId: contractId,
      databaseId: databaseId
    }),
    request
  );
}

export function turnOff(contractId, databaseId, request) {
  return axios.put(
    api.path("contractDatabase.turnOff", {
      contractId: contractId,
      databaseId: databaseId
    }),
    request
  );
}

export function listMetrics(contractId, request) {
  return axios.get(
    api.path("contractDatabase.metricsList", {
      contractId: contractId,
    }),
    request
  );
}

export function showMetrics(contractId, databaseId) {
  return axios.get(
    api.path("contractDatabase.metricsShow", {
      contractId: contractId,
      databaseId: databaseId
    })
  );
}

export function showBackups(contractId, databaseId) {
  return axios.get(
    api.path("contractDatabase.backupsShow", {
      contractId: contractId,
      databaseId: databaseId
    })
  );
}

